import { Fragment, useEffect, useState } from "react";
import { Label, TextInput } from "flowbite-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import useAPI from "hooks/useAPI";
import { login } from "redux/slices/auth";
import MirumBtn from "components/MirumBtn";
import DetailsModal from "./components/DetailsModal";
import CodeValidate from "./components/CodeValidate";
import useAccount from "hooks/useAccount";
import BubblesBg from "components/BubblesBg";
import { useCorporateMode } from "context/CorporateModeContext";

const Login = ({ onLoggedIn, onDidDismiss, showBubbles }) => {
  const { isCorporate } = useCorporateMode();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  let history = useHistory();
  const { API } = useAPI({});
  // const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false);
  const { getAndSetUser } = useAccount();
  const [showCodeValidateModal, setShowCodeValidateModal] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    checkAndSetRedirectTo();
    if (user._id) {
      if (window.location.pathname === "/login") {
        goToDashboard();
      }
    }
  }, []);

  const checkAndSetRedirectTo = () => {
    let params = new URLSearchParams(window.location.search);
    let sId = params.get("sid");
    if (sId) {
      setRedirectTo(`/?sid=${sId}`);
    }
  };

  const goToDashboard = () => {
    let url = "/";
    if (redirectTo) {
      url += redirectTo;
    }
    history.push(url);
  };

  // const [forceCheck, setForceCheck] = useState(false);

  // useEffect(() => {
  //   checkLogInAndCollectMandatoryDetails();
  // }, [user._id]);

  // useEffect(() => {
  //   if (forceCheck) {
  //     checkLogInAndCollectMandatoryDetails();
  //   }
  // }, [forceCheck]);

  // const checkLogInAndCollectMandatoryDetails = async () => {
  //   console.log("checkLogInAndCollectMandatoryDetails", user);
  //   if (user._id) {
  //     const mandatoryDetails = ["name", "mobileNumber", "dob"];

  //     //Check if we're missing any mandatory details
  //     const missingDetails = mandatoryDetails.filter(
  //       (detail) => !user[detail] || user[detail] === ""
  //     );

  //     //If we're missing any mandatory details, show details modal
  //     if (missingDetails.length > 0) {
  //       console.log("missing details...", missingDetails, user);
  //       setShowDetailsModal(true);
  //     } else {
  //       console.log("not missing anything...");
  //       if (onLoggedIn) {
  //         console.log("onLoggedIn");
  //         onLoggedIn();
  //       } else {
  //         console.log("logged in push url");
  //         history.push("/");
  //       }
  //     }
  //   } else {
  //     console.log("No user id", user._id);
  //     setHasBeenSubmitted(false);
  //   }
  //   setForceCheck(false);
  // };

  const submit = async (values) => {
    try {
      setHasBeenSubmitted(true);
      // const data = await API.post(`/login`, values);
      const data = await API.post(`/user/code`, values);
      console.log("data: ", data);
      setShowCodeValidateModal(true);
      // dispatch(
      //   login({
      //     user: data.user,
      //   })
      // );
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email address").required("Required"),
    // password: Yup.string().min(1, "Too Short!").required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      // password: "",
    },
    validateOnMount: true,
    validationSchema: LoginSchema,
    onSubmit: submit,
  });

  const { email } = formik.values;

  return (
    <Fragment>
      {showBubbles && !isCorporate && <BubblesBg />}
      {!hasBeenSubmitted && (
        <div>
          <div className="w-full bg-[white] relative">
            <img
              src="/images/blur-bubble-small-bg.jpg"
              className="absolute top-0 left-0 w-full h-full"
            />
            <img
              src="/images/bg-swirl-white.png"
              className="w-full relative pt-[25%] top-1"
            />
            <div className="w-full h-full flex items-center justify-center absolute top-0 left-0">
              {/* //logo */}
              <img src="/images/mirum-logo.png" className="w-1/2 mt-[-10%]" />
            </div>
          </div>
          <div className="container mx-auto">
            <div className="text-center w-3/4 mx-auto">
              <h3 className="mb-2">login</h3>
              <p className="lowercase">
                Enter your email address below and we'll send you a one time
                passcode to log you in. Don't worry, if you don't have an
                account then one will be set up for you
              </p>
            </div>
            <br />
            <div className="text-left w-3/4 mx-auto pb-8">
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="email" value="email" />
                    </div>
                    <TextInput
                      id="email"
                      type="email"
                      className="mirum-text-field"
                      value={email}
                      onChange={formik.handleChange}
                      required={true}
                      placeholder="enter your email address"
                    />
                  </div>
                  {/* <div>
                  <div className="mb-2 block">
                    <Label htmlFor="password" value="Password" />
                  </div>
                  <TextInput
                    id="password"
                    type="password"
                    value={password}
                    onChange={formik.handleChange}
                    required={true}
                  />
                </div> */}
                  <div className="w-full p-4 flex items-center justify-center mt-4">
                    <div className="w-1/2 min-width-[100px]">
                      <MirumBtn type="submit" className="w-full">
                        continue
                      </MirumBtn>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {showDetailsModal && (
        <DetailsModal
          user={user}
          onDetailsSubmitted={async () => {
            setShowDetailsModal(false);
            await getAndSetUser();
            setForceCheck(true);
          }}
        />
      )} */}
      {showCodeValidateModal && (
        <CodeValidate
          show={showCodeValidateModal}
          email={email}
          onCodeValidated={async () => {
            console.log("onCodeValidated");
            setShowCodeValidateModal(false);
            await getAndSetUser();

            if (window.location.pathname.indexOf("login") > -1) {
              history.push(redirectTo ? redirectTo : "/");
            }
            // setForceCheck(true);
          }}
          onDidDismiss={
            onDidDismiss
              ? onDidDismiss
              : () => {
                  console.log("onDidDismiss");
                  setShowCodeValidateModal(false);
                  if (window.location.pathname.indexOf("login") > -1) {
                    history.push(redirectTo ? redirectTo : "/");
                  }
                }
          }
        />
      )}
    </Fragment>
  );
};

export default Login;
